"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=clamav.js.map